import { useAuthStore } from '@/stores/useAuthStore'

/**
 * Authoritative admin check lives on the server — this hook is only used to
 * decide whether to show the /admin link and render the admin UI. Every admin
 * API call is still gated on the backend by email match, so a user who
 * bypasses this hook gets 403s and an empty dashboard.
 */
export const ADMIN_EMAIL = 'ashishsingh.v7.7@gmail.com'

export function useIsAdmin(): boolean {
  const user = useAuthStore((state) => state.user)
  const email = user?.email?.toLowerCase() ?? ''
  return email === ADMIN_EMAIL
}
